export function PageLoading() {
  return (
    <div
      className="page-loading"
      role="status"
      aria-live="polite"
      data-testid="page-loading"
    >
      <span
        className="page-loading__spinner"
        aria-hidden
        data-testid="page-loading-spinner"
      />
      <span data-testid="page-loading-text">Loading…</span>
    </div>
  );
}
